import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

interface KeyValue {
  key: string;
  value: any;
}

@Injectable({ providedIn: 'root' })
export class IndexedDbService {
  private dbPromise: Promise<IDBPDatabase>;

  constructor() {
    this.dbPromise = openDB('MyDB', 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('KeyValueStore')) {
          db.createObjectStore('KeyValueStore', { keyPath: 'key' });
        }
      }
    });
  }

  // 🔹 CREATE / UPDATE
  async saveData(key: string, value: any): Promise<void> {
    const db = await this.dbPromise;
    await db.put('KeyValueStore', { key, value });
  }

  // 🔹 READ (by key)
  async getData(key: string): Promise<any | null> {
    const db = await this.dbPromise;
    const result = await db.get('KeyValueStore', key);
    return result ? result.value : null;
  }

  // 🔹 READ ALL
  async getAll(): Promise<KeyValue[]> {
    const db = await this.dbPromise;
    return await db.getAll('KeyValueStore');
  }

  // 🔹 DELETE (by key)
  async deleteData(key: string): Promise<void> {
    const db = await this.dbPromise;
    await db.delete('KeyValueStore', key);
  }

  // 🔹 CLEAR ALL
  async clear(): Promise<void> {
    const db = await this.dbPromise;
    await db.clear('KeyValueStore');
  }
}
